 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Bjs":"Bjs","CulturalRelicNotice":"CulturalRelicNotice","CulturalRelicSignResult":"CulturalRelicSignResult","CulturalRelicSignUp":"CulturalRelicSignUp","CulturalRelicSignUpNotice":"CulturalRelicSignUpNotice","Download":"Download","Educational":"Educational","EducationalClassroom":"EducationalClassroom","EducationalReview":"EducationalReview","EducationalSignResult":"EducationalSignResult","EducationalSignup":"EducationalSignup","ExhibitList":"ExhibitList","GuideFloor":"GuideFloor","GuideHome":"GuideHome","GuideMap":"GuideMap","Home":"Home","LookJinSoul":"LookJinSoul","Notice":"Notice","RichText":"RichText","Shyg":"Shyg","VideoOnline":"VideoOnline","VolunteerIndex":"VolunteerIndex","VolunteerReview":"VolunteerReview","VolunteerRichText":"VolunteerRichText","VolunteerSignResult":"VolunteerSignResult","VolunteerSignUp":"VolunteerSignUp","activityRegistration":"activityRegistration","culturalRelic":"culturalRelic","culturalRelicMyResule":"culturalRelicMyResule","culturalRelicQueryResule":"culturalRelicQueryResule","culturalRelicSignResults":"culturalRelicSignResults","exhibitRichText":"exhibitRichText","exhibitSwiper~exhibitSwiperDitile":"exhibitSwiper~exhibitSwiperDitile","exhibitSwiper":"exhibitSwiper","exhibitSwiperDitile":"exhibitSwiperDitile","exhibitVideo":"exhibitVideo","musicList":"musicList","myResule":"myResule","queryResule":"queryResule","relicsRichText":"relicsRichText","video":"video","voiceExplain":"voiceExplain"}[chunkId]||chunkId) + "." + {"Bjs":"905b2878","CulturalRelicNotice":"4e184fd6","CulturalRelicSignResult":"030aee3b","CulturalRelicSignUp":"cad2414b","CulturalRelicSignUpNotice":"93ed2230","Download":"c59e6db3","Educational":"e409ba21","EducationalClassroom":"faafe448","EducationalReview":"8f0ea246","EducationalSignResult":"27ca172c","EducationalSignup":"3d963fa4","ExhibitList":"9153bf82","GuideFloor":"21a25915","GuideHome":"b2d1d33b","GuideMap":"c35830ec","Home":"ef0edf7a","LookJinSoul":"936b55a2","Notice":"3aac8dba","RichText":"ae00de11","Shyg":"99df67e1","VideoOnline":"e24b7770","VolunteerIndex":"0538611a","VolunteerReview":"02e15b75","VolunteerRichText":"d882a8fc","VolunteerSignResult":"807e6521","VolunteerSignUp":"599db4d5","activityRegistration":"f4ae653b","culturalRelic":"32cf3145","culturalRelicMyResule":"5803d707","culturalRelicQueryResule":"5d99a7e0","culturalRelicSignResults":"bebb3162","exhibitRichText":"6d424434","exhibitSwiper~exhibitSwiperDitile":"29dceb5f","exhibitSwiper":"ef6aa0bc","exhibitSwiperDitile":"41a20ada","exhibitVideo":"a52f2bfe","musicList":"b6e31f88","myResule":"bc1b7e84","queryResule":"4eb3f209","relicsRichText":"030509c0","video":"f8fff5e7","voiceExplain":"17b045e1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Bjs":1,"CulturalRelicNotice":1,"CulturalRelicSignResult":1,"CulturalRelicSignUp":1,"CulturalRelicSignUpNotice":1,"Download":1,"Educational":1,"EducationalClassroom":1,"EducationalReview":1,"EducationalSignResult":1,"EducationalSignup":1,"ExhibitList":1,"GuideFloor":1,"GuideHome":1,"GuideMap":1,"Home":1,"LookJinSoul":1,"Notice":1,"RichText":1,"Shyg":1,"VideoOnline":1,"VolunteerIndex":1,"VolunteerReview":1,"VolunteerRichText":1,"VolunteerSignResult":1,"VolunteerSignUp":1,"activityRegistration":1,"culturalRelic":1,"culturalRelicMyResule":1,"culturalRelicQueryResule":1,"culturalRelicSignResults":1,"exhibitRichText":1,"exhibitSwiper~exhibitSwiperDitile":1,"exhibitSwiper":1,"exhibitSwiperDitile":1,"exhibitVideo":1,"musicList":1,"myResule":1,"queryResule":1,"relicsRichText":1,"video":1,"voiceExplain":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Bjs":"Bjs","CulturalRelicNotice":"CulturalRelicNotice","CulturalRelicSignResult":"CulturalRelicSignResult","CulturalRelicSignUp":"CulturalRelicSignUp","CulturalRelicSignUpNotice":"CulturalRelicSignUpNotice","Download":"Download","Educational":"Educational","EducationalClassroom":"EducationalClassroom","EducationalReview":"EducationalReview","EducationalSignResult":"EducationalSignResult","EducationalSignup":"EducationalSignup","ExhibitList":"ExhibitList","GuideFloor":"GuideFloor","GuideHome":"GuideHome","GuideMap":"GuideMap","Home":"Home","LookJinSoul":"LookJinSoul","Notice":"Notice","RichText":"RichText","Shyg":"Shyg","VideoOnline":"VideoOnline","VolunteerIndex":"VolunteerIndex","VolunteerReview":"VolunteerReview","VolunteerRichText":"VolunteerRichText","VolunteerSignResult":"VolunteerSignResult","VolunteerSignUp":"VolunteerSignUp","activityRegistration":"activityRegistration","culturalRelic":"culturalRelic","culturalRelicMyResule":"culturalRelicMyResule","culturalRelicQueryResule":"culturalRelicQueryResule","culturalRelicSignResults":"culturalRelicSignResults","exhibitRichText":"exhibitRichText","exhibitSwiper~exhibitSwiperDitile":"exhibitSwiper~exhibitSwiperDitile","exhibitSwiper":"exhibitSwiper","exhibitSwiperDitile":"exhibitSwiperDitile","exhibitVideo":"exhibitVideo","musicList":"musicList","myResule":"myResule","queryResule":"queryResule","relicsRichText":"relicsRichText","video":"video","voiceExplain":"voiceExplain"}[chunkId]||chunkId) + "." + {"Bjs":"a03bcdab","CulturalRelicNotice":"113a6afd","CulturalRelicSignResult":"8ad64348","CulturalRelicSignUp":"2fe44390","CulturalRelicSignUpNotice":"a2a7f9d7","Download":"57e71ac2","Educational":"df3d1afa","EducationalClassroom":"5d63923e","EducationalReview":"21d8ba90","EducationalSignResult":"b69b9507","EducationalSignup":"d588b99b","ExhibitList":"2aab42e4","GuideFloor":"b415ba71","GuideHome":"52f0543f","GuideMap":"74913f7d","Home":"a008b4b9","LookJinSoul":"bf65a68c","Notice":"6b0f02c9","RichText":"60c82849","Shyg":"f7c0588f","VideoOnline":"f20fb3c2","VolunteerIndex":"9e31d07f","VolunteerReview":"c427f5a6","VolunteerRichText":"4ff18be9","VolunteerSignResult":"26e28a3f","VolunteerSignUp":"a9ed2daf","activityRegistration":"833c6f8e","culturalRelic":"775af6a2","culturalRelicMyResule":"5f838424","culturalRelicQueryResule":"cbc5b6e9","culturalRelicSignResults":"fc508866","exhibitRichText":"384e86dc","exhibitSwiper~exhibitSwiperDitile":"708358d5","exhibitSwiper":"b72be472","exhibitSwiperDitile":"376382bf","exhibitVideo":"a9060ed1","musicList":"95886f55","myResule":"632d53b7","queryResule":"5f198466","relicsRichText":"e9de6c4c","video":"4363f4cf","voiceExplain":"265c5789"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
